import type { WovarProduct } from "@commercekit/api";
import type { HTMLComponent } from "@commercekit/react";
import { useErrorAlert } from "@commercekit/react";
import { useCart } from "@commercekit/remix";
import { useEffect, useMemo, useState } from "react";
import { useWvAddToCart } from "~/hooks/useDataLayer";
import { usePrismicLabels } from "~/hooks/usePrismicLabel";
import { AddToCartLoadingOrSuccess } from "./WvRelatedProductActionButton";

const WvCategoryActionBar: HTMLComponent<{
  product: WovarProduct;
}> = ({ product }) => {
  const { $pt } = usePrismicLabels();
  const { show } = useErrorAlert();
  const [addToCartLoading, setAddToCartLoading] = useState(false);

  const { addToCart, loadingQueue, cartLoading, resultQueue, clearResult } =
    useCart();

  const isLoading = useMemo(
    () =>
      (loadingQueue.find((i) => i.id === product.id) && cartLoading) ||
      addToCartLoading,
    [loadingQueue, cartLoading, product.id, addToCartLoading]
  );

  const cartError = useMemo(() => {
    if (!resultQueue?.length) return null;
    const error = resultQueue.find((result) => result.actionFail);
    return error?.error ? error.error : null;
  }, [resultQueue]);

  useEffect(() => {
    if (!cartLoading && resultQueue?.length) {
      clearResult();
      if (cartError) {
        show(cartError, "warning");
        // setAddToCartSuccess(false);
        setAddToCartLoading(false);
      } else {
        setAddToCartLoading(false);
      }
    }
  }, [resultQueue, cartLoading, clearResult, show, cartError]);
  const gtmAddToCart = useWvAddToCart();
  return (
    <div className="col-auto pt-1 pt-lg-0 productblock__addtocart">
      <button
        className="px-1 pt-2 d-flex align-items-center"
        type="button"
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          setAddToCartLoading(true);
          addToCart({ ...product, quantity: 1 });
          gtmAddToCart(product, 1);
        }}
      >
        <span className="productblock__addtocart-icon" data-icon-before="">
          <svg width="25" height="23" xmlns="http://www.w3.org/2000/svg">
            <g fill="#FFF" fillRule="nonzero">
              <path d="M8.53 18.882a1.882 1.882 0 100 3.765 1.882 1.882 0 000-3.765zM21.706 18.882a1.882 1.882 0 100 3.765 1.882 1.882 0 000-3.765zM4.765.059c.45 0 .836.318.923.757l.004.02L8.378 16.06h14.27c.513 0 .93.411.94.922V17a.941.941 0 01-.922.941H7.588a.941.941 0 01-.923-.757l-.004-.02L3.975 1.94H1a.941.941 0 01-.941-.922V1C.059.486.47.069.98.059H4.765z"></path>
              <path d="M23.673 3.864c.636-.205 1.338.338 1.21 1.063l-.005.022-1.694 8.47a.941.941 0 01-.902.757H7.588a.941.941 0 01-.018-1.882h13.92l1.317-6.588H5.706a.941.941 0 01-.941-.923v-.018c0-.514.411-.931.922-.941h17.705c.09 0 .178.012.263.037l.014.004h.004z"></path>
            </g>
          </svg>
        </span>
        <span className="ml-2" data-text="Added">
          {$pt("category_page_add_directly")}
        </span>

        <AddToCartLoadingOrSuccess className="ml-1" loading={isLoading} />
      </button>
    </div>
  );
};

export default WvCategoryActionBar;
